import { TemplatePageProps } from './types'
import { TwentyOneGoldEntity } from './entity'
import Icon from 'images/games/21-gold/icon.png'
import Detail1 from 'images/games/21-gold/detail1.png'
import { Pocket7GamesSwiper } from './pocket7games'
import {
  DominoesLink,
  DunkShotLink,
  MatchNFlipLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  PoolClashLink,
  TileBlitzLink,
} from '../../components'

export const TwentyOneGoldDetail: TemplatePageProps = {
  entity: {
    ...TwentyOneGoldEntity,
    logo: Icon,
    title: <>21 Gold: Master the Online Blackjack Game </>,
    description: (
      <>
        Experience a fresh twist on the <strong>blackjack game</strong> with <strong>21 Gold</strong>, a skill-based
        real-money <strong>card game</strong> where your aim is to stack four lanes of cards to exactly 21 without
        busting. <strong>Play blackjack</strong> for fun or compete for real cash prizes—available now in the{' '}
        <strong>Pocket7Games</strong> app!
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: <>How to Play 21 Gold?</>,
      description: (
        <>
          <strong>21 Gold</strong> is the ultimate mobile <strong>21 card game</strong>! Following{' '}
          <strong>blackjack rules</strong>, stack cards in four lanes to hit 21 without busting—three strikes, and
          you&#39;re out! Aces can count as 1 or 11, and Wild Jacks clear any lane fast. Stacks can also be cleared when
          5 cards line up in a column. Hold cards briefly, undo mistakes, or draw new ones to stay in play. Your first
          two moves are key, so think ahead. With every strategic move, you get closer to winning. It’s{' '}
          <strong>online blackjack</strong> right on your mobile device!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Got What It Takes to Hit 21? </>,
      description: (
        <>
          <strong>21 Gold</strong> puts a fun, strategic spin on classic blackjack, designed for skill-based and
          real-money competition. With flexible Aces, powerful Wild Jacks, and special features like card holding and
          undo options, every move counts. Matches are multiplayer or 1v1, blending quick decision-making with real
          skill. Whether playing just for fun or for real money prizes, every game challenges your memory, timing, and
          decision-making!
          <br />
          <br />
          Want to explore more exciting games like 21 Gold? Download the{' '}
          <Pocket7GamesLink>
            <strong>Pocket7Games</strong> App
          </Pocket7GamesLink>{' '}
          and enjoy Avia&#39;s skill games like <MatchNFlipLink strong />, <PlaySolitaireOnlineLink strong />,{' '}
          <TileBlitzLink strong />, <NumbersBlitzLink strong />, <PoolClashLink strong />, <DunkShotLink strong />, and{' '}
          <DominoesLink strong /> to relax, compete, and win real money!
        </>
      ),
    },
  ],
} as TemplatePageProps
